<template>
  <div class="mswlanding" :class="{ pc: !tabletAndMobile }">
    <div class="mswlanding__hero">
      <a href="https://maplestoryworlds.nexon.com/en/download" target="_blank"
        ><button id="sticky-play" class="sticky-button button-cta">Play</button></a
      >
      <video v-if="!tabletAndMobile" class="mswlanding__video-bg" autoplay loop muted playsinline>
        <source src="@/assets/video/MSW_SL_Trailer_Loop_v3.mp4" type="video/mp4" />
      </video>
      <video v-else class="mswlanding__video-bg" autoplay loop muted playsinline>
        <source src="@/assets/video/MSW_SL_Trailer_Loop_v4.mp4" type="video/mp4" />
      </video>
      <div class="mswlanding__hero__content">
        <img src="@/assets/images/landing/logo.webp" alt="Maplestory Worlds" class="mswlanding__hero__logo" />
        <TextOutline color="#ffe500" class="hero-text1">
          Explore, Discover, and Play! There is a World for Everyone!
        </TextOutline>
        <div class="buttons">
          <a href="https://maplestoryworlds-creators.nexon.com/en" target="_blank"
            ><button id="header-start-building">Start Building</button></a
          >
          <a href="https://maplestoryworlds.nexon.com/en/play" target="_blank">
            <button id="header-discover-worlds" class="button-signup" @click="scrollToSignUp">Discover Worlds</button>
          </a>
        </div>
        <!-- <TextOutline color="white" class="hero-text2">
          Immerse yourself in a new way to play! In MapleStory Worlds,<br />
          players and creators come together to explore magical experiences.
        </TextOutline> -->
        <!-- <div class="sign-up">
          <TextOutline color="white">Sign Up Now</TextOutline>
          <div class="arrow-down-btn" @click="scrollToSignUp" />
        </div> -->
      </div>
    </div>
    <div class="body">
      <div id="box-1" class="box signup ani-1">
        <Transition mode="out-in" name="fade">
          <div v-if="!emailSubmitSuccess" class="submit-form" :class="{ loading }">
            <Loading class="loading" />
            <Transition name="fade">
              <div v-if="emailSubmitSystemError" class="error-dialog">
                <div>
                  <i-mdi-close class="close" @click="emailSubmitSystemError = false" />
                  <img src="@/assets/images/landing/error-icon.png" alt="Error" />
                  <div>An error occurred. Please try again later.</div>
                </div>
              </div>
            </Transition>
            <h2>Join Our Mailing List!</h2>
            <form @submit.prevent="formSubmit">
              <p>
                Be the first to receive the latest news, special rewards, and more when you sign up for MapleStory
                Worlds newsletters!
              </p>
              <input
                v-model="vEmail"
                type="text"
                class="input-email"
                :class="{ error: emailErrorMsg }"
                placeholder="Email Address"
                @submit.prevent="formSubmit"
              />
              <Transition name="fade">
                <div v-if="emailErrorMsg" class="error-msg"><i-mdi-error /> {{ emailErrorMsg }}</div>
              </Transition>
              <div class="agree-terms">
                <input id="checkbox" v-model="vAgree" type="checkbox" />
                <label for="checkbox" class="prevent-select" :class="{ error: checkboxErrorMsg }">
                  By checking this box, you agree to our
                  <a
                    id="signup-tou"
                    href="https://maplestoryworlds.nexon.com/en/legal/tos/1013"
                    class="text-link"
                    target="_blank"
                    >Terms of Use</a
                  >
                  and acknowledge that you have read and understand our
                  <a
                    id="signup-pp"
                    href="https://maplestoryworlds.nexon.com/en/legal/tos/1007"
                    class="text-link"
                    target="_blank"
                    >Privacy Policy</a
                  >.
                </label>
              </div>
              <Transition name="fade">
                <div v-if="checkboxErrorMsg" class="error-msg"><i-mdi-error />{{ checkboxErrorMsg }}</div>
              </Transition>
              <button type="submit" class="submit-button primary button-signup">Stay In Touch</button>
              <div class="recaptcha">
                This site is protected by reCAPTCHA Enterprise and the<br />
                Google
                <a href="https://policies.google.com/privacy" class="text-link" target="_blank">Privacy Policy</a> and
                <a href="https://policies.google.com/terms" class="text-link" target="_blank">Terms of Service</a>
                apply.
              </div>
            </form>
          </div>
          <div v-else class="success">
            <div>
              <h2>Thank you for signing up!</h2>
              <p>You have successfully signed up to receive MapleStory Worlds newsletters.</p>
            </div>
          </div>
        </Transition>
      </div>
      <div id="box-2" class="box ani-1">
        <h2 v-if="tabletAndMobile">What is MapleStory Worlds?</h2>
        <h2 v-else>
          <div>What is</div>
          MapleStory Worlds?
        </h2>
        <p>
          MapleStory Worlds is a UGC platform where players can build, explore, and monetize their unique games. With
          intuitive tools and access to 30M+ assets, creators of all levels can bring ideas to life. Players can explore
          a delightful range of Worlds catering to all play styles. There is a perfect World waiting just for you!
          Explore. Discover. Play!
        </p>
      </div>
      <div id="box-players" class="box players ani-1">
        <h2 v-if="tabletAndMobile">
          <div>Worlds Built for</div>
          Everyone
        </h2>
        <div class="swiper-area">
          <swiper class="main-swiper" :modules="modules" :thumbs="{ swiper: thumbsSwiper2, autoScrollOffset: 1 }">
            <swiper-slide
              v-for="(one, index) in playersSlides"
              :key="index"
              @click="showDialogFunc(playersSlides, index)"
            >
              <template v-if="one.youtubeId">
                <img :src="`https://img.youtube.com/vi/${one.youtubeId}/maxresdefault.jpg`" />
                <i class="play-icon" />
              </template>
              <img v-else :src="one.image" />
            </swiper-slide>
          </swiper>
          <swiper
            class="thumb-swiper"
            :modules="modules"
            :space-between="mobile ? 12 : '2%'"
            :slides-per-view="mobile ? '2.5' : 4"
            :free-mode="true"
            :watch-slides-progress="true"
            @swiper="(swiper) => (thumbsSwiper2 = swiper)"
          >
            <swiper-slide v-for="(one, index) in playersSlides" :key="index">
              <template v-if="one.youtubeId">
                <img :src="`https://img.youtube.com/vi/${one.youtubeId}/maxresdefault.jpg`" />
                <i class="play-icon" />
              </template>
              <img v-else :src="one.image" />
            </swiper-slide>
          </swiper>
        </div>
        <div class="text-area">
          <h2 v-if="!tabletAndMobile">Worlds Built for <br />Everyone</h2>
          <p>
            Create your own deck in Maple Duel, face exciting monsters using your unique strategy in Maple Slash, or
            embark on a thrilling adventure among dinosaurs in Durango: The Lost Island. There are abundant distinct
            fantastic worlds waiting for you to explore!
          </p>
          <a id="players-learn-more" href="//maplestoryworlds.nexon.com/en/play" target="_blank"
            ><button>Discover Worlds</button></a
          >
        </div>
      </div>
      <div id="box-creators" class="box creators ani-1">
        <h2 v-if="tabletAndMobile">
          <div>Meet Creators</div>
          Changing the Game
        </h2>
        <div class="swiper-area column-size-3">
          <swiper class="main-swiper" :modules="modules" :thumbs="{ swiper: thumbsSwiper, autoScrollOffset: 1 }">
            <swiper-slide
              v-for="(one, index) in creatorsSlides"
              :key="one.name"
              @click="showDialogFunc(creatorsSlides, index)"
            >
              <template v-if="one.youtubeId">
                <img :src="`https://img.youtube.com/vi/${one.youtubeId}/maxresdefault.jpg`" />
                <i class="play-icon" />
              </template>
              <img v-else :src="one.image" />
            </swiper-slide>
          </swiper>
          <swiper
            class="thumb-swiper"
            :modules="modules"
            :space-between="10"
            :slides-per-view="mobile ? '2.5' : 3"
            :free-mode="true"
            :watch-slides-progress="true"
            @swiper="(swiper) => (thumbsSwiper = swiper)"
          >
            <swiper-slide v-for="one in creatorsSlides" :key="one.name"
              ><template v-if="one.youtubeId">
                <img :src="`https://img.youtube.com/vi/${one.youtubeId}/maxresdefault.jpg`" />
                <i class="play-icon" />
              </template>
              <img v-else :src="one.image"
            /></swiper-slide>
          </swiper>
        </div>
        <div class="text-area">
          <h2 v-if="!tabletAndMobile">
            <div>Meet Creators</div>
            <div>Changing the Game</div>
          </h2>
          <p>
            Discover how our creators are turning their ideas into reality. From puzzle games to battle arenas, this
            thriving community is shaping the future of MapleStory Worlds. With no limit to what you can make, what will
            you build next?
          </p>
          <a id="creators-learn-more" href="//maplestoryworlds-creators.nexon.com/en" target="_blank"
            ><button>Start Building</button></a
          >
        </div>
      </div>
      <div id="box-circle" class="box ani-1">
        <h2>Join the Creator Circle</h2>
        <p>
          We developed this ongoing monthly program to amplify the work of promising creators like yourself. Whether
          you’re just starting out or an experienced creator, the Creator Circle provides mentorship, promotion, and
          financial support (<b>$3,500 USD</b> monthly stipend) to help you build the next great world.
        </p>
        <a
          id="circle-learn-more"
          href="https://maplestoryworlds-creators.nexon.com/en/community/5479/5485/2665788"
          target="_blank"
        >
          <button>Apply Today</button>
        </a>
      </div>
      <div id="box-discord" class="box ani-1">
        <h2>Share Your Thoughts</h2>
        <p>
          Have a suggestion? Want to be part of the community? Chat with us on
          <a id="box-discord-link" href="https://discord.gg/YansfK5gwC" class="text-link" target="_blank">Discord</a>!
        </p>
        <p>
          Found a bug in a Nexon World or the MapleStory Worlds Platform? Report it to our
          <a
            id="box-discord-support-link"
            href="https://support-maplestoryworlds.nexon.com/"
            class="text-link"
            target="_blank"
            >Support Center</a
          >!
        </p>
      </div>
      <div id="box-sns" class="box ani-1">
        <h2>Join Us!</h2>
        <div class="sns-description">Follow our social pages for the latest news and updates!</div>
        <div class="sns-platforms">
          <a v-for="sp in socialPlatforms" :id="`sns-${sp.id}-link`" :key="sp.id" :href="sp.link" target="_blank">
            <SocialIcons :type="sp.id.toLowerCase()" />
          </a>
        </div>
      </div>
      <div>
        <button class="primary ani-1" @click="scrollToSignUp">Stay In Touch</button>
      </div>
      <div>
        <a id="back-to-main-site" href="//maplestoryworlds.nexon.com/en/play" class="bottom-link text-link ani-1"
          >Back to Main Site</a
        >
      </div>
    </div>
    <v-dialog v-model="showDialog" :opacity="0.9">
      <div class="dialog-frame">
        <img class="close-btn" src="@/assets/images/landing/x.png" @click="showDialog = false" />
        <swiper
          class="main-swiper"
          :modules="[Navigation]"
          :auto-height="true"
          :watch-slides-progress="true"
          :navigation="{ prevEl: '.swiper-prev', nextEl: '.swiper-next' }"
          :initial-slide="dialogInitialSlide"
          @slide-change="onSlideChange"
          @after-init="onSlideChange"
        >
          <swiper-slide v-for="(one, index) in dialogSlides" :key="index">
            <iframe
              v-if="one.youtubeId"
              class="dialog-youtube"
              :src="`https://www.youtube.com/embed/${one.youtubeId}?enablejsapi=1${
                dialogInitialSlide === 0 ? '&autoplay=0' : ''
              }`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img v-if="one.image" :src="one.image" />
            <div class="dialog-bottom">
              <template v-if="one.name">
                <h2>{{ one.name }}</h2>
                <div class="title">- {{ one.title }} -</div>
                <div class="desc">{{ one.description }}</div>
              </template>
              <a
                v-if="one.playNowButton"
                :href="one.playNowButtonLink ? one.playNowButtonLink : 'https://maplestoryworlds.nexon.com/en/download'"
                target="_blank"
                ><button class="button-cta">Play Now</button></a
              >
            </div>
          </swiper-slide>
        </swiper>
        <div class="nav-btn swiper-prev" />
        <div class="nav-btn right swiper-next" />
      </div>
    </v-dialog>
    <Footer />
  </div>
</template>
<script setup>
import TextOutline from '@/components/TextOutline.vue'
import { preSignupApi } from '@/services/api'
import { onMounted, ref, nextTick, watch } from 'vue'
import { loadScript } from '../../services/utils'

import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText' // Import SplitText

import armandoImg from '@/assets/images/landing/creators/armando-d.webp'
import jaredImg from '@/assets/images/landing/creators/jared.webp'
import stephenImg from '@/assets/images/landing/creators/stephen-a.webp'
import { useDisplay } from 'vuetify'

import duelImg from '@/assets/images/landing/players/duel.webp'
import durangoImg from '@/assets/images/landing/players/durango.webp'
import slashImg from '@/assets/images/landing/players/slash.webp'

import 'swiper/css'

import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

const { mobile, smAndDown: tabletAndMobile } = useDisplay()

const modules = [FreeMode, Thumbs]

const thumbsSwiper = ref(null)
const thumbsSwiper2 = ref(null)
const showDialog = ref(false)
const dialogInitialSlide = ref(0)

const creatorsSlides = [
  {
    name: 'Stephen A.',
    title: 'Creator of MarbleQuest',
    description:
      '“Having multiple basic mechanics ready when you first create a world makes it much easier to get things up and running.”',
    image: stephenImg,
  },
  {
    name: 'Jared A.',
    title: 'Creator of Everel',
    description: '“If you are an experienced coder you will be right at home in their API Reference.”',
    image: jaredImg,
  },
  {
    name: 'Armando D.',
    title: 'Creator of Maple Survivor',
    description: '“The engine itself is fairly easy to learn and fun to use.”',
    image: armandoImg,
  },
]

const playersSlides = [
  {
    image: duelImg,
    playNowButton: true,
    playNowButtonLink: 'https://maplestoryworlds.nexon.com/en/play/e92c6726261c4c1795c369b5e66f1efa/',
  },
  {
    image: slashImg,
    playNowButton: true,
    playNowButtonLink: 'https://maplestoryworlds.nexon.com/en/play/dcd9c5fee74142c9b0d7fbb4d1bccb1e/',
  },
  {
    image: durangoImg,
    playNowButton: true,
    playNowButtonLink: 'https://maplestoryworlds.nexon.com/en/play/e967c59f15f3418a843256894801df29/',
  },
  {
    youtubeId: 'BzRTmGMNKbc',
    playNowButton: true,
  },
]

const dialogSlides = ref(creatorsSlides)
const prevYTVideo = ref(null)

const onSlideChange = (swiper) => {
  // Access the active slide index
  const activeIndex = swiper.activeIndex
  if (prevYTVideo.value && prevYTVideo.value.contentWindow) {
    prevYTVideo.value.contentWindow.postMessage(`{"event":"command","func":"pauseVideo","args":""}`, '*')
  }
  var youtubePlayer = document.querySelector(`.dialog-frame .swiper-slide:nth-child(${activeIndex + 1}) iframe`)
  if (youtubePlayer) {
    youtubePlayer.contentWindow.postMessage(`{"event":"command","func":"playVideo","args":""}`, '*')
    prevYTVideo.value = youtubePlayer
  }
}

function showDialogFunc(slides, initialSlide = 0) {
  showDialog.value = true
  dialogInitialSlide.value = initialSlide
  dialogSlides.value = slides
}

const socialPlatforms = [
  { id: 'X', link: 'https://x.com/MSWorlds_EN' },
  { id: 'Youtube', link: 'https://www.youtube.com/@MapleStoryWorlds_EN' },
  { id: 'Instagram', link: 'https://www.instagram.com/maplestoryworlds_en/' },
  { id: 'Twitch', link: 'https://www.twitch.tv/maplestoryworldsen' },
  { id: 'Discord', link: 'https://discord.gg/YansfK5gwC' },
  { id: 'TikTok', link: 'https://www.tiktok.com/@maplestoryworlds_en' },
]
const vEmail = ref('')
const vAgree = ref(false)
const formSubmitted = ref(false)
const emailErrorMsg = ref('')
const checkboxErrorMsg = ref('')
const loading = ref(false)
const emailSubmitSuccess = ref(false)
const emailSubmitSystemError = ref(false)

function isValidEmail(email) {
  // Define the regex pattern for a valid email address
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  // Test the email against the pattern
  return emailPattern.test(email)
}

watch([vAgree, formSubmitted], () => {
  if (formSubmitted.value) {
    checkboxErrorMsg.value = vAgree.value ? '' : 'Please agree to the terms.'
  }
})

watch([vEmail, formSubmitted], () => {
  if (formSubmitted.value) {
    emailErrorMsg.value = vEmail.value.length === 0 ? 'Please enter an email address.' : ''
    if (vEmail.value.trim() && !isValidEmail(vEmail.value)) {
      emailErrorMsg.value = 'Please enter a valid email address.'
    }
  }
})

onMounted(() => {
  loadScript(
    'recaptcha-api',
    `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`
  )

  gsap.registerPlugin(ScrollTrigger, SplitText) // Register SplitText

  // Animate boxes on scroll
  gsap.utils.toArray('.ani-1').forEach((dom) => {
    gsap.fromTo(
      dom,
      { opacity: 0, y: 30, scale: 0.9, rotation: 'random(-10, 10)' },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        rotation: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: dom,
          start: 'top 85%', // Trigger when 80% of the box is visible
          end: 'bottom 100%', // End when the bottom of the box is visible
          toggleActions: 'play none none none', // Play the animation once
          // markers: true, // Uncomment for debugging ScrollTrigger
        },
      }
    )
  })

  // Animate h2 tags with SplitText on scroll
  gsap.utils.toArray('.box h2').forEach((h2) => {
    // Target h2 tags within .box elements
    const split = new SplitText(h2, { type: 'chars,words,lines' }) // Split by characters and words
    gsap.from(split.words, {
      // Animate characters
      y: -100,
      opacity: 0,
      rotation: 'random(-80, 80)',
      duration: 0.7,
      ease: 'back',
      stagger: 0.15,
      scrollTrigger: {
        trigger: h2,
        start: 'top 85%', // Adjust as needed
        toggleActions: 'play none none none',
        // markers: true, // Uncomment for debugging
      },
    })
  })
})

async function getRecaptchaToken() {
  return new Promise((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action: 'subscribe' }).then(resolve)
    })
  })
}

function formSubmit() {
  formSubmitted.value = true
  nextTick(async () => {
    if (emailErrorMsg.value || checkboxErrorMsg.value) {
      return
    }

    loading.value = true
    const recaptchaToken = await getRecaptchaToken()
    // console.log('recaptchaToken', recaptchaToken)

    preSignupApi
      .post('/no-auth/user', {
        productId: '59794',
        eventNo: 1,
        gamePlatform: 'web',
        email: vEmail.value,
        reCAPTCHAToken: recaptchaToken,
      })
      .then(() => {
        emailSubmitSuccess.value = true
      })
      .catch((error) => {
        console.error(error)
        if (error.response && error.response.headers['x-arena-web-errorcode']) {
          const errorCode = error.response.headers['x-arena-web-errorcode']
          if (errorCode === '31303') {
            emailErrorMsg.value = 'This email address has already been used to sign up.'
          } else {
            emailSubmitSystemError.value = true
          }
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}

function scrollToSignUp() {
  document.getElementById('box-1').scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' })
}
</script>

<style lang="scss" scoped>
@use '@/assets/scss/pages/landing/buttons.scss';
@use '@/assets/scss/pages/landing/desktop';
@use '@/assets/scss/pages/landing/mobileTablet';

@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap');

.close-btn {
  position: absolute;
  cursor: pointer;
  right: 0;
  top: -60px;
}

iframe {
  width: 100%;
  aspect-ratio: 16/9;
  z-index: 1;
}
.dialog-frame {
  width: 75%;
  height: 90%;
  position: relative;
  margin: 0 auto;
  .swiper-slide {
    max-height: 90vh;
    overflow-y: auto;
  }
  .swiper-button-disabled {
    display: none;
  }
}

.nav-btn {
  position: absolute;
  display: inline-flex;
  top: 50%;
  left: 0;
  cursor: pointer;
  transform: translate(-150%, -50%);
  aspect-ratio: 1/1;
  width: min(62px, 7vw);
  background-image: url(@/assets/images/landing/arrow-left.png);
  background-size: cover;
  &.right {
    left: initial;
    right: 0;
    transform: translate(150%, -50%) scaleX(-1);
  }
  &:hover {
    background-image: url(@/assets/images/landing/arrow-left-hover.png);
  }
}

.dialog-bottom {
  color: white;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
  font-family: 'Quicksand', sans-serif;
  row-gap: 10px;
  h2 {
    margin: 0;
  }
  .title {
    color: #f7966b;
  }
}

@media only screen and (max-width: 479px) {
  .dialog-frame {
    width: 80%;
  }
  .nav-btn {
    width: 24px;
    aspect-ratio: 24/44;
    background-image: url(@/assets/images/landing/arrow-left-m.png);
    &:hover {
      background-image: url(@/assets/images/landing/arrow-left-hover-m.png);
    }
  }
}
</style>
<style>
.grecaptcha-badge {
  visibility: hidden;
}
</style>
